import { FormControl, FormLabel, Text } from "@chakra-ui/react";
import React, { FC } from "react";
import { FieldRenderProps } from "react-final-form";
import { DefaultFieldProps } from "../../types";
import Select from "react-select";
import { useQuery } from "@apollo/client";
import { GET_BARANGAYS } from "./queries";
import { get } from "lodash";

type Option = {
  value: any;
  label: any;
};
interface SelectBarangayFieldProps extends DefaultFieldProps {
  defaultVal?: any;
  options: Option[];
  menuPortalTarget?: any;
  selectMenuPosition?: any;
  selectMenuPortalzIndex?: number;
  selectCustomStyles?: any;
  isDisabled?: boolean;
  isLoading?: boolean;
  isClearable?: boolean;
  city_code?: any;
}

const SelectBarangayField: FC<
  FieldRenderProps<SelectBarangayFieldProps & any>
> = (props) => {
  const {
    defaultVal,
    formGroupProps,
    labelProps,
    errorProps,
    label,
    meta,
    input,
    menuPortalTarget = null,
    selectMenuPosition = "absolute",
    selectMenuPortalzIndex = 3000,
    selectCustomStyles,
    isDisabled,
    isClearable,
    city_code,
  } = props;

  const { data, loading } = useQuery(GET_BARANGAYS, {
    variables: {
      city_code: city_code,
    },
    fetchPolicy: "network-only",
    skip: !city_code,
  });

  const barangays = get(data, "barangays", []);

  const options = barangays.map((barangay: any) => {
    return {
      label: barangay.brgy_name,
      value: barangay.brgy_code,
    };
  });

  return (
    <FormControl {...formGroupProps} position="relative">
      <FormLabel {...labelProps}>{label}</FormLabel>
      <Select
        {...input}
        value={options.find((option: any) => option.value === input.value)}
        className="basic-single"
        classNamePrefix="select"
        isDisabled={isDisabled}
        isLoading={loading}
        isClearable={isClearable}
        styles={{
          ...selectCustomStyles,
          menuPortal: (styles: any) => {
            return {
              ...styles,
              zIndex: selectMenuPortalzIndex,
            };
          },
        }}
        defaultValue={defaultVal}
        isSearchable={true}
        options={options || []}
        noOptionsMessage={() => "No Options available."}
        menuPortalTarget={menuPortalTarget}
        menuPosition={selectMenuPosition}
        onChange={(val: any) => {
          input.onChange(val.value);
        }}
      />
      {meta.error && meta.touched && (
        <Text
          {...errorProps}
          color="red.300"
          fontSize="sm"
          textAlign="end"
          mx="3"
          position="absolute"
          right={0}
        >
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default SelectBarangayField;
